/**
 * Task #3148 — prodotto/edition servito da QUESTA build frontend.
 *
 * La FE tenant attuale è la superficie Easyflow: se il tenant loggato ha un
 * prodotto diverso (da `/api/my-modules` → `product`), il ModuleProvider
 * blocca il render con una schermata di rifiuto. Nessun prodotto hardcodato
 * fuori da questa costante: label e catalogo arrivano da PRODUCT_REGISTRY.
 */
import type { TenantProduct } from '@easyflow/shared';

export const FRONTEND_PRODUCT: TenantProduct = 'easyflow';
